<div class="modal-header">
	<button class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">
		{{#if isNew}}
		{{TR "Wert definieren"}}
		{{else}}
		{{TR "Wert konfigurieren"}}: {{formData.name}}
		{{/if}}
	</h4>
</div>
<div class="modal-body">
	{{#if errors.error}}
	<div class="alert alert-danger">
		{{TR errors.error}} {{#if errors.sysErr}}({{ERROR_TR errors.sysErr}}){{/if}}
	</div>
	{{/if}}
	{{#if configWarning}}
	<div id="js-config-hint-box" class="alert alert-warning">
		<strong>{{TR "Hinweis"}}</strong>: {{configWarning}}
	</div>
	{{/if}}
	<div class="row m-b-20">
		<div class="col-sm-8">
			<div class="form-group">
				<label for="name" class="control-label">{{TR "Name"}}</label>
				<input type="text" class="form-control {{#if errors.name}}parsley-error{{/if}}" id="name-input" name="name" placeholder="{{TR "Bezeichnung des Wertes"}}" value="{{TR_DATAPOINT device formData.name}}">
				{{#if errors.name}}
				<ul class="parsley-errors-list filled" id="js-name-error">
					<li class="parsley-required">{{TR errors.name}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
		<div class="col-sm-4">
			<div class="form-group">
				<label for="update_class_select" class="control-label">{{TR "Aktualisierung"}}</label>
				<select class="form-control" id="update_class_select-input" name="update_class_select">
					<option value="1" {{EQ "1" formData.update_class "selected"}}>1</option>
					<option value="2" {{EQ "2" formData.update_class "selected"}}>2</option>
					<option value="3" {{EQ "3" formData.update_class "selected"}}>3</option>
				</select>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-4">
			<div class="form-group">
				<label for="type_select" class="control-label">{{TR "Typ"}}</label>
				{{#SELECT formData.type_select}}
				<select id="type_select-input" class="form-control js-type-select" name="type_select" {{#unless isNew}}disabled{{/unless}}>
					<option value="MBR">{{TR "Holding Register"}}</option>
					<option value="MBC">{{TR "Coil"}}</option>
					{{#if canConfigureNonDefaultModbusDataPoints}}
					<option value="MBI">{{TR "Input Register"}}</option>
					<option value="MBD">{{TR "Discrete Input"}}</option>
					{{/if}}
				</select>
				{{/SELECT}}
			</div>
		</div>
		<div class="col-sm-4">
			<div class="form-group">
				<label for="nr" class="control-label">{{TR "Adresse"}}</label>
				<input id="nr-input" class="form-control {{#if errors.nr}}parsley-error{{/if}}" type="number" name="nr" placeholder="{{TR "Nummer"}}" value="{{formData.nr}}" min="1" max="65553" {{#unless isNew}}disabled{{/unless}}>
				{{#if errors.nr}}
				<ul class="parsley-errors-list filled" id="js-nr-error">
					<li class="parsley-required">{{TR errors.nr}}</li>
				</ul>
				{{/if}}
				{{#unless isAlwaysReadonly}}
				<input type="checkbox" name="is_readonly" id="js-readonly" {{#if isPredefined}}disabled{{/if}} {{IS_CHECKED formData.is_readonly}}>
				{{/unless}}
				<span>{{TR "Schreibgeschützt"}}</span>
			</div>
		</div>
		<div class="col-sm-4">
			<div class="form-group">
				<label for="length" class="control-label">{{TR "Länge"}}</label>
				<input type="number" class="form-control {{#if errors.length}}parsley-error{{/if}}"id="length-input" {{#unless isNew}}disabled{{else}}{{#COMPARE formData.data_type "==" "float"}}disabled{{/COMPARE}}{{/unless}} name="length" placeholder="{{TR "Länge"}}" value="{{DEFAULT formData.length 1}}" min="1" max="4">
				{{#if errors.length}}
				<ul class="parsley-errors-list filled" id="js-length-error">
					<li class="parsley-required">{{TR errors.length}}</li>
				</ul>
				{{/if}}
				{{#COMPARE formData.type_class_select "==" "MBR"}}
				{{#unless isPredefined}}
				<input type="checkbox" name="is_signed" id="js-signed" {{IS_CHECKED formData.is_signed}}>
				<span>{{TR "Vorzeichenbehaftet"}}</span></br>
				<input type="checkbox" name="is_little_endian" id="js-little_endian" {{IS_CHECKED formData.is_little_endian}}>
				<span>{{TR "Little-Endian-Format"}}</span></br>
				<input type="checkbox" name="is_decimal_combination" id="js-decimal_combination" {{IS_CHECKED formData.is_decimal_combination}}>
				<span>{{TR "Dezimal-Kombination (10^3)"}}</span>
				{{/unless}}
				{{/COMPARE}}
			</div>
		</div>
	</div>
	<hr />
	{{#COMPARE formData.type_class_select "==" "MBR"}}
	<div id="js-extra-register-options">
	<div class="row">
		<div class="col-sm-4">
			<div class="form-group">
				<label for="min" class="control-label">{{TR "Rohwert Anfang"}}</label>
				<input type="number" class="form-control {{#if errors.min}}parsley-error{{/if}}" id="min-input" {{#if isPredefined}}disabled{{/if}} name="min" placeholder="0" value="{{DEFAULT formData.min 0}}">
				{{#if errors.min}}
				<ul class="parsley-errors-list filled" id="js-min-error">
					<li class="parsley-required">{{TR errors.min}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
		<div class="col-sm-4">
			<div class="form-group">
				<label for="max" class="control-label">{{TR "Rohwert Ende"}}</label>
				<input type="number" class="form-control {{#if errors.max}}parsley-error{{/if}}" id="max-input" {{#if isPredefined}}disabled{{/if}} name="max" placeholder="65535" value="{{DEFAULT formData.max 65535}}">
				{{#if errors.max}}
				<ul class="parsley-errors-list filled" id="js-max-error">
					<li class="parsley-required">{{TR errors.max}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-8">
			<div class="form-group">
				<label for="data_type_select" class="control-label">{{TR "Datentyp"}}</label>
				{{#SELECT formData.data_type}}
				<select class="form-control" id="data_type_select-input" {{#if isPredefined}}disabled{{/if}} name="data_type_select">
					{{#each dataTypes}}
					<option value="{{value}}">{{name}}</option>
					{{/each}}
				</select>
				{{/SELECT}}
			</div>
			{{#COMPARE formData.data_type "==" "value_mapping"}}
			<div class="row">
				<div class="col-xs-6">
					<div class="form-group">
						<label for="vmapping_min" class="control-label">{{TR "Anzeige Anfang"}}</label>
						<input type="number" class="form-control" id="vmapping_min-input" {{#if isPredefined}}disabled{{/if}} name="vmapping_min" placeholder="0" value="{{formData.value_mapping.[0]}}">
					</div>
				</div>
				<div class="col-xs-6">
					<div class="form-group">
						<label for="vmapping_max" class="control-label">{{TR "Anzeige Ende"}}</label>
						<input type="number" class="form-control" id="vmapping_max-input" {{#if isPredefined}}disabled{{/if}} name="vmapping_max" placeholder="1000" value="{{formData.value_mapping.[1]}}">
					</div>
				</div>
			</div>
			{{/COMPARE}}
			{{#COMPARE formData.data_type "==" "value_resolution"}}
				<div class="row">
					<div class="col-xs-3">
						{{TR "Wert"}}
					</div>
					<div class="col-xs-9">
						{{TR "Ersatztext"}}
					</div>
				</div>
				{{> VALUE_TABLE valueConfiguration}}
				{{#if valueConfiguration.canAddEntry}}
				<div class="row">
					<div class="col-xs-3">
						<button id="js-add-resolution" class="btn btn-white btn-sm m-t-5"><i class="fa fa-plus" /></button>
					</div>
				</div>
				{{/if}}
			{{/COMPARE}}
		</div>
		<div class="col-sm-4">
			<div class="form-group">
				<label for="unit" class="control-label">{{TR "Einheit"}}</label>
				<input type="text" class="form-control {{#if errors.unit}}parsley-error{{/if}}" {{#unless isNew}}{{#unless canChangeUnit}}disabled="disabled"{{/unless}}{{/unless}} id="unit-input" name="unit" placeholder="{{TR "Einheit"}}" value="{{formData.unit}}">
				{{#if errors.unit}}
				<ul class="parsley-errors-list filled" id="js-unit-error">
					<li class="parsley-required">{{TR errors.unit}}</li>
				</ul>
				{{/if}}
				<input type="checkbox" name="unitFixed" id="js-fixed-unit" {{IS_CHECKED formData.is_unit_fixed}}>
				<span>{{TR "Einheit vorgeben"}}</span>
			</div>
		</div>
	</div>
	</div>
	{{/COMPARE}}
	{{#COMPARE formData.type_class_select "==" "MBC"}}
	<div id="js-extra-coil-options">
	<div class="row">
		<div class="col-xs-6">
			<div class="form-group">
				<label for="cmapping_0" class="control-label">{{TR "Anzeige Coil = 0"}}</label>
				<input type="string" class="form-control" id="cmapping_0-input" name="cmapping_0" placeholder="{{TR 'AUS'}}" value="{{formData.coil_mapping.[0]}}">
			</div>
		</div>
		<div class="col-xs-6">
			<div class="form-group">
				<label for="cmapping_1" class="control-label">{{TR "Anzeige Coil = 1"}}</label>
				<input type="string" class="form-control" id="cmapping_1-input" name="cmapping_1" placeholder="{{TR 'AN'}}" value="{{formData.coil_mapping.[1]}}">
			</div>
		</div>
	</div>
	</div>
	{{/COMPARE}}
</div>
<div class="modal-footer">
	<div class="pull-left">
		<button id="js-test-config" class="btn btn-white m-r-5" {{#if testDisabled}}disabled{{/if}}>{{TR "Test"}}</button>
		{{#if testResultIsFetched}}
		<i class="fa fa-spin fa-spinner" />
		{{else}}
		{{#if testResult}}<span id="js-test-results">{{{testResult}}}</span>{{/if}}
		{{/if}}
	</div>
	<button id="ct-cancel" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button class="btn {{#if smartTempActive}}disabled btn-grey {{else}} btn-primary{{/if}}" id="js-save">{{TR "Speichern"}}</button>
</div>
